import { Injectable } from '@angular/core';
import {
  Actions,
  Effect,
  ofType
} from '@ngrx/effects';
import {
  catchError,
  map,
  mergeMap
} from 'rxjs/operators';
import {
  Action
} from '@ngrx/store';
import {
  Observable,
  of
} from 'rxjs';

import * as watchlistSnapshotsActions from '../actions/watchlist-snapshots.actions';
import { WatchlistSnapshotsService } from '../service/watchlist-snapshots.service';


@Injectable()
export class WatchlistSnapshotsEffects {

  /**
   * Fetches a watchlist snapshot
   * Dispatches either succeeded or failed action afterwards
   */
  @Effect()
  fetchItem$: Observable<Action> = this._actions.pipe(
    ofType(watchlistSnapshotsActions.FETCH_ITEM),
    map(action => action.payload),
    mergeMap((payload) => this._watchlistSnapshotsService.getWatchlistSnapshot(payload.uuid).pipe(
      map(watchlistSnapshots => new watchlistSnapshotsActions.FetchItemSucceededAction(watchlistSnapshots)),
      catchError(error => of(new watchlistSnapshotsActions.FetchItemFailedAction(error)))
    )
    )
  );


  /**
   * @param _actions
   * @param _watchlistSnapshotsService
   */
  constructor(private _actions: Actions<watchlistSnapshotsActions.Actions>,
              private _watchlistSnapshotsService: WatchlistSnapshotsService) {}

}
